import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Servicio para manejar operaciones de scroll en la aplicación
 * Útil para resolver problemas de posicionamiento después de navegación
 */
@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Hace scroll hacia la parte superior de la página
   * @param behavior - Tipo de scroll: 'smooth' para animación suave, 'auto' para instantáneo
   */
  scrollToTop(behavior: ScrollBehavior = 'auto'): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior,
      });
    } catch (error) {
      // Fallback para navegadores más antiguos
      window.scrollTo(0, 0);
    }
  }

  /**
   * Hace scroll a una posición específica en píxeles
   * @param position - Posición en píxeles desde el top
   * @param behavior - Tipo de scroll: 'smooth' para animación suave, 'auto' para instantáneo
   */
  scrollToPosition(position: number, behavior: ScrollBehavior = 'auto'): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      window.scrollTo({
        top: position,
        left: 0,
        behavior: behavior,
      });
    } catch (error) {
      // Fallback para navegadores más antiguos
      window.scrollTo(0, position);
    }
  }

  /**
   * Hace scroll a un elemento específico por su ID
   * @param elementId - ID del elemento HTML
   * @param behavior - Tipo de scroll: 'smooth' para animación suave, 'auto' para instantáneo
   */
  scrollToElement(
    elementId: string,
    behavior: ScrollBehavior = 'smooth'
  ): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: behavior, block: 'start' });
    }
  }
}
